module MyNotifications
{
    var notificationListItem = `
                    <td class="triggerTypeDropdown"></td>
                    <td class="notificationTypeDropdown"></td>
                    <td style="max-width: 150px; overflow: hidden;">ModelNotificationAddress</td>
                    <td style="max-width: 150px;"><span class="customTextDropdown"></span><span class="customNotificationLabel" stlye="overflow: hidden;">ModelNotificationText</span></td>
                    <td class="thresholdMin">ModelThresholdMin</td>
                    <td class="thresholdMax">ModelThresholdMax</td>
                    <td align="center">
                        <a class="btn btn-sm btn-danger" onclick="MyNotifications.DeleteNotification(ModelID2)"><span class="hidden-xs">` + localizer["MyNotificationsDelete"] + ` </span><em class="fa fa-trash"></em></a>
                    </td>`;

    var theTriggers: CustomerAPI.Trigger[];
    var headingStart = document.getElementById('NotificationsHeading').innerHTML;
    let notificationImei: string;
    export function Initialize(imei : string) {
        var theTriggers: CustomerAPI.Trigger[];
        notificationImei = imei;
        RequireLoginGetTriggers(imei, triggers => InitializeTriggers(triggers));
        RequireLogin(() => MyFunc());
    }

    export function InitializeTriggers(triggers: CustomerAPI.Trigger[]) { 
        theTriggers = triggers;
        InitializeTriggersView();
    }

    export function MyFunc() {
        if (!notificationImei)
            return;
        webUser.devices.forEach(device => {
            if (device.imei.toString() == notificationImei) {
                document.getElementById('NotificationsHeading').innerHTML = headingStart + " " + device.name;
                return;
            }
        });
    }

    export function InitializeTriggersView() {
        document.getElementById('NotificationsList').innerHTML = "";
        theTriggers.forEach(trigger => {
            AddTrigger(trigger);
        });
    }

    export function AddTrigger(trigger: CustomerAPI.Trigger) {
        var notificationType = "??";
        var notificationAddress = "??";
        if (trigger.action === 1) {
            notificationType = "Epost";
            notificationAddress = trigger.emailAddress;
        }
        if (trigger.action === 2) {
            notificationType = "SMS";
            if (trigger.phoneNumber != null && trigger.phoneNumber.charAt(0) != "+") {
                trigger.phoneNumber = "+" + webUser.countryCode.toString() + trigger.phoneNumber;
            }
            notificationAddress = trigger.phoneNumber;
        }

        var address = notificationAddress;
        var min = trigger.minValue;
        var max = trigger.maxValue;

        var addressLabel = EditableLabel.Create(notificationAddress, (newName, id) => {
            if (trigger.action === 1)
                trigger.emailAddress = newName;
            if (trigger.action === 2)
                trigger.phoneNumber = newName;
            CustomerAPI.notificationService.put(trigger.id, trigger, () => { }, (ex, reason) => EditableLabel.SetText(id, address));
            EditableLabel.Close(id);
        });

        var customText = trigger.customNotificationText;

        var notificationTextLabel = EditableLabel.Create(customText, (newValue, id) => {
            trigger.customNotificationText = newValue;

            CustomerAPI.notificationService.put(trigger.id, trigger, () => { customText = trigger.customNotificationText }, (ex, reason) => EditableLabel.SetText(id, customText));
            EditableLabel.Close(id);
        });

        var minLabel = EditableLabel.Create(min.toString().replace('.', ','), (newValue, id) => {
            newValue = newValue.substring(0, 5);
            EditableLabel.SetText(id, newValue);

            var value = parseFloat(newValue.replace(",", "."));
            if (value === NaN)
                value = 0;
            trigger.minValue = value;

            if (trigger.minValue >= trigger.maxValue) {
                trigger.maxValue = trigger.minValue + 1;
            }

            CustomerAPI.notificationService.put(trigger.id, trigger, () =>
            {
                min = trigger.minValue;
                max = trigger.maxValue;
                EditableLabel.SetText(minLabel.id, "" + min);
                EditableLabel.SetText(maxLabel.id, "" + max);
            }, (ex, reason) => EditableLabel.SetText(id, "" + min));
            EditableLabel.Close(id);
        });
        var maxLabel = EditableLabel.Create(max.toString().replace('.', ','), (newValue, id) => {
            newValue = newValue.substring(0, 5);
            EditableLabel.SetText(id, newValue);

            var value = parseFloat(newValue.replace(",", "."));
            if (value === NaN)
                value = 0;
            trigger.maxValue = value;

            if (trigger.maxValue <= trigger.minValue) {
                trigger.minValue = trigger.maxValue - 1;
            }

            CustomerAPI.notificationService.put(trigger.id, trigger, () =>
            {
                min = trigger.minValue;
                max = trigger.maxValue;
                EditableLabel.SetText(minLabel.id, "" + min);
                EditableLabel.SetText(maxLabel.id, "" + max);
            }, (ex, reason) => EditableLabel.SetText(id, "" + max));
            EditableLabel.Close(id);
        });

        var maxSuffix = document.createElement("span");
        maxSuffix.id = "maxSuffix" + maxLabel.id;
        maxSuffix.innerText = trigger.valueSuffix;
        var minSuffix = document.createElement("span");
        minSuffix.id = "minSuffix" + minLabel.id;
        minSuffix.innerText = trigger.valueSuffix;

        var deviceHTML = notificationListItem.replace("ModelIMEI", trigger.unitId).replace("ModelNotificationAddress", addressLabel.html).replace("ModelNotificationText", notificationTextLabel.html).replace("ModelThresholdMin", minLabel.html + minSuffix.outerHTML).replace("ModelThresholdMax", maxLabel.html + maxSuffix.outerHTML).replace("ModelID2", "" + trigger.id);

        var element = document.createElement("tr");
        element.setAttribute("id", "row" + trigger.id);
        element.innerHTML = deviceHTML;
        
        var triggerTypeDropdown = DropDownBox.Create(x => {
            trigger.triggerType = x == localizer["Voltage"] ? "Voltage1" : "Temp";

            var isVoltage = trigger.triggerType == "Voltage1";
            trigger.valueSuffix = isVoltage ? "V" : "℃";

            trigger.minValue = isVoltage ? 12.2 : 3;
            trigger.maxValue = isVoltage ? 13.5 : 30;
            trigger.valueSuffix = isVoltage ? "V" : "℃";

            $("#" + minSuffix.id).text(trigger.valueSuffix);
            $("#" + maxSuffix.id).text(trigger.valueSuffix);

            CustomerAPI.notificationService.put(trigger.id, trigger, (tr) => {
                $("#NotificationsList #row" + trigger.id + " .thresholdMin span.lbl").text(trigger.minValue);
                $("#NotificationsList #row" + trigger.id + " .thresholdMax span.lbl").text(trigger.maxValue);
            }, (ex, reason) => console.log("Failed", ex, reason));
        });
        DropDownBox.AddOption(triggerTypeDropdown, localizer["Voltage"], trigger.triggerType == 'Voltage1');
        DropDownBox.AddOption(triggerTypeDropdown, localizer["Temperature"], trigger.triggerType == 'Temp');
        triggerTypeDropdown.appendTo(element.getElementsByClassName("triggerTypeDropdown")[0]);        

        var notificationTypeDropdown = DropDownBox.Create(x => {
            trigger.action = x == localizer["Sms"] ? CustomerAPI.ActionType.Sms : CustomerAPI.ActionType.Mail;

            EditableLabel.SetText(addressLabel.id, trigger.action === 1 ? trigger.emailAddress : trigger.phoneNumber);

            CustomerAPI.notificationService.put(trigger.id, trigger, () => { }, (ex, reason) => alert("Failed"));
        });
        DropDownBox.AddOption(notificationTypeDropdown, localizer["Email"], trigger.action == CustomerAPI.ActionType.Mail);
        DropDownBox.AddOption(notificationTypeDropdown, localizer["Sms"], trigger.action == CustomerAPI.ActionType.Sms);
        notificationTypeDropdown.appendTo(element.getElementsByClassName("notificationTypeDropdown")[0]);

        var customTextDropdown = DropDownBox.Create(newValue => {
            if (newValue == localizer["NotificationTextDefault"]) {
                trigger.useCustomNotification = false;
                trigger.showValueInCustomNotification = false;
            }
            else if (newValue == localizer["NotificationTextCustomWithValue"]) {
                trigger.useCustomNotification = true;
                trigger.showValueInCustomNotification = true;
            }
            else if (newValue == localizer["NotificationTextCustomWithoutValue"]) {
                trigger.useCustomNotification = true;
                trigger.showValueInCustomNotification = false;
            }

            // set custom notification label visibility
            var customNotificationLabel = element.getElementsByClassName("customNotificationLabel")[0];
            if (trigger.useCustomNotification)
            {
                if (customNotificationLabel.classList.contains("hideContent"))
                {
                    customNotificationLabel.classList.remove("hideContent");
                }
            }
            else
            {
                if (!customNotificationLabel.classList.contains("hideContent"))
                {
                    customNotificationLabel.classList.add("hideContent");
                }
            }

            CustomerAPI.notificationService.put(trigger.id, trigger, () => { }, (ex, reason) => alert("Failed"));
        });
        DropDownBox.AddOption(customTextDropdown, localizer["NotificationTextDefault"], !trigger.useCustomNotification);
        DropDownBox.AddOption(customTextDropdown, localizer["NotificationTextCustomWithValue"], trigger.useCustomNotification && trigger.showValueInCustomNotification);
        DropDownBox.AddOption(customTextDropdown, localizer["NotificationTextCustomWithoutValue"], trigger.useCustomNotification && !trigger.showValueInCustomNotification);
        customTextDropdown.appendTo(element.getElementsByClassName("customTextDropdown")[0]);

        // set custom notification label visibility
        var customNotificationLabel = element.getElementsByClassName("customNotificationLabel")[0];
        if (trigger.useCustomNotification) {
            if (customNotificationLabel.classList.contains("hideContent")) {
                customNotificationLabel.classList.remove("hideContent");
            }
        }
        else {
            if (!customNotificationLabel.classList.contains("hideContent")) {
                customNotificationLabel.classList.add("hideContent");
            }
        }

        document.getElementById('NotificationsList').appendChild(element);
    }

    export function AddNotification(type: CustomerAPI.ActionType, triggerType: string = "Voltage1") {
        var trigger = new CustomerAPI.Trigger();
        trigger.id = 0;
        trigger.unitId = notificationImei;
        trigger.triggerType = triggerType;
        trigger.emailAddress = webUser.email;
        trigger.phoneNumber = "+" + webUser.countryCode.toString() + webUser.phoneNumber;
        var isVoltage = triggerType == "Voltage1";
        trigger.minValue = isVoltage ? 12.2 : 3;
        trigger.maxValue = isVoltage ? 13.5 : 30;
        trigger.valueSuffix = triggerType ? "V" : "℃";
        trigger.action = type;

        CustomerAPI.notificationService.post(trigger, success => {
            if (success != undefined) {
                AddTrigger(success);
            }
            else
                alert("Success but success was null? " + success); // TODO localize?
        }, fail => {
            alert(localizer["MyNotificationsCreateFailed"] + ": " + fail);
        });
    }

    export function UpdateNotification(trigger: CustomerAPI.Trigger) {
        CustomerAPI.notificationService.put(trigger.id, trigger,
            success => {
                //todo should read back and update page
            },
            fail => {
                //todo page should not be updated. Show some warning
            },
        );
    }

    export function DeleteNotification(id:string) {
        if (confirm(localizer["MyNotificationsDeleteConfirmation"].replace("{{id}}", id))) {
            var idInt = parseInt(id);
            CustomerAPI.notificationService.delete(idInt, success => {
                var element = document.getElementById("row" + id);
                document.getElementById('NotificationsList').removeChild(element);
            }, fail => {
                alert(localizer["MyNotificationsDeleteFailed"] + ": " + fail);
            });

        }
    }
}